import type { CollectedDataOption } from '@onefootprint/request-types/dashboard';
import type { IdentityDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import type { FormIdentityData } from '../../collect-data-node/components/person/person.types';
import { fromOutputMappings } from '../../shared/verified-prefill-outputs';

const createIdentityDataPayload = (node: IdentityDataNodeProps, formData: FormIdentityData) => {
  const { successor: _, subject: __, ...data } = node.data;
  return {
    // TODO: remove this when we can no longer mutate CollectDataNodes on the frontend
    // for now, this just makes sure we don't have an invalid node update here
    customRequirements: [],
    ...data,
    residentialAddressCountries: formData.residentialAddressCountries,
    mustCollectData: [...removeMustCollectData(node), ...createMustCollectData(formData)],
    optionalData: [...removeOptionalData(node), ...createOptionalData(formData)],
    useCompactConfirm: formData.useCompactConfirm,
    disabledCdos: formData.disabledCdos,
    confirmationMode: formData.confirmationMode,
    enabledVerifiedPrefill: formData.enabledVerifiedPrefill,
    verifiedPrefillSettings: formData.enabledVerifiedPrefill
      ? {
          challengeKind: formData.challengeKind,
          skipIfPopulated: [
            ...(formData.skipIfSsnPopulated ? (['ssn9'] as const) : []),
            ...(formData.skipIfFullAddressPopulated ? (['full_address'] as const) : []),
          ],
          outputs: fromOutputMappings(formData.outputs),
        }
      : undefined,
  };
};

const removeMustCollectData = (node: IdentityDataNodeProps) => {
  const { subject: _, successor: __, ...data } = node.data;
  const mustCollectData = data.mustCollectData.filter(option => {
    return !['email', 'phone_number', 'ssn4', 'ssn9', 'us_legal_status', 'us_tax_id'].includes(option);
  });
  return mustCollectData;
};

const removeOptionalData = (node: IdentityDataNodeProps) => {
  const { subject: _, successor: __, ...data } = node.data;
  const optionalData = data.optionalData.filter(option => !['ssn4', 'ssn9'].includes(option));
  return optionalData;
};

const createMustCollectData = (formData: FormIdentityData): Array<CollectedDataOption> => {
  const mustCollectData: Array<CollectedDataOption> = [];
  if (formData.email) {
    mustCollectData.push('email');
  }
  if (formData.phoneNumber) {
    mustCollectData.push('phone_number');
  }
  if (formData.ssn.collect && !formData.ssn.optional) {
    mustCollectData.push(formData.ssn.kind);
  }
  if (formData.usLegalStatus) {
    mustCollectData.push('us_legal_status');
  }
  return mustCollectData;
};

const createOptionalData = (formData: FormIdentityData): Array<CollectedDataOption> => {
  const optionalData: Array<CollectedDataOption> = [];
  if (formData.ssn.optional) {
    optionalData.push(formData.ssn.kind);
  }
  return optionalData;
};

export default createIdentityDataPayload;
